import React, { useContext, useState, useEffect } from 'react';
//import PageLoading from './common/loaders/pageLoading'
import { Row, Tag, Button, Col, Icon, Menu, Layout } from 'antd';
import { Link } from "react-router-dom";
import ActivateAccount from '../../pages/dashboard/activate-account/index';
import { AuthContext } from '../../context/auth';
import {
    useQuery
} from "@apollo/client";
import { ME } from '../../utils/query';
import FormLoading from '../common/loaders/formLoading'
import { Redirect } from 'react-router-dom';

const { Sider } = Layout;
const { SubMenu } = Menu;

function MyMenu(theMode) {
    const mode = theMode.theMode;
    return (
        <Menu mode={mode}>
            <Menu.Item key="1">
                <Link to={'/dashboard'}>

                    <span className="submenu-title-wrapper">
                        <Icon type="dashboard" />
                        داشبورد
                    </span>

                </Link>
            </Menu.Item>
            <Menu.Item key="2">
                <Link to={'/dashboard/profile'}>

                    <span className="submenu-title-wrapper">
                        <Icon type="user" />
                        پروفایل
                    </span>

                </Link>
            </Menu.Item>
            <Menu.Item key="3">
                <Link to={'/dashboard/notifications'}>

                    <span className="submenu-title-wrapper">
                        <Icon type="notification" />
                        اعلانات
                    </span>

                </Link>
            </Menu.Item>

            <Menu.Item key="13">
                <Link to={'/dashboard/reserve-time'}>

                    <span className="submenu-title-wrapper">
                        <Icon type="carry-out" />
                        نوبت حضوری
                    </span>

                </Link>
            </Menu.Item>

            <SubMenu
                title={
                    <span className="submenu-title-wrapper">
                        <Icon type="retweet" />
                        حواله
                    </span>
                }
            >
                <Menu.Item key="61">
                    <Link to="/dashboard/transfer/active">

                        <span className="submenu-title-wrapper">
                            حواله‌ها
                        </span>

                    </Link>
                </Menu.Item>

                <Menu.Item key="61">
                    <Link to="/dashboard/transfer/nima">

                        <span className="submenu-title-wrapper">
                            درخواست ارز نیمایی
                        </span>

                    </Link>
                </Menu.Item>

                <Menu.Item key="62">
                    <Link to="/dashboard/transfer/sana">

                        <span className="submenu-title-wrapper">
                            درخواست ارز سنایی
                        </span>

                    </Link>
                </Menu.Item>

                <Menu.Item key="63">
                    <Link to="/dashboard/transfer/history" >

                        <span className="submenu-title-wrapper">
                            تاریخچه حواله‌ها
                        </span>

                    </Link>
                </Menu.Item>

            </SubMenu>



            <SubMenu
                title={
                    <span className="submenu-title-wrapper">
                        <Icon type="dollar" />
                        خدمات ارز مسافرتی
                    </span>
                }
            >
                <Menu.Item key="73">
                    <Link to="/dashboard/passenger-money" >

                        <span className="submenu-title-wrapper">
                            تاریخچه معاملات
                        </span>

                    </Link>
                </Menu.Item>
                <Menu.Item key="71">
                    <Link to="/dashboard/passenger-money/request" >
                        <span className="submenu-title-wrapper">
                            درخواست خرید
                        </span>
                    </Link>
                </Menu.Item>

            </SubMenu>
            <Menu.Item key="4">
                <Link to={'/forms'}>

                    <span className="submenu-title-wrapper">
                        <Icon type="file-text" />
                        فرم‌ها
                    </span>

                </Link>
            </Menu.Item>



        </Menu>
    )
}

export default function DashboardLayout(props) {
    const { user, login, logout } = useContext(AuthContext);
    const isMobile = window.innerWidth >= 1000 ? false : true;

    const [drawerOpen, setDrawerOpen] = useState(!isMobile);

    const { loading, error, data } = useQuery(ME);

    function checkUserIsConfirmed(data) {
        if (data.email_verified === true &&
            data.mobile_verified === true &&
            data.documents_status === "approved") {
            return true;
        }
        else return false;
    }


        const userIsConfirmed = checkUserIsConfirmed(user.user);
        return (
            <Row>
                <Col span={24} style={{ paddingRight: isMobile === true ? 0 : 200 }}>
                    <div style={{ position: 'fixed', top: 1, left: 0, display: isMobile ? 'block' : 'none' }}>
                        <button type={'button'} style={{ border: 0 }} onClick={() => { setDrawerOpen(!drawerOpen) }} className={"leftAccssItem"}>
                            <div className="leftAccssItemIcon">
                                <Icon type={drawerOpen ? 'close' : 'menu'} />
                            </div>
                            <div className="leftAccssItemText">
                                <p>پنل کاربری</p>
                            </div>
                        </button>
                    </div>
                    <div>
                        <div className="dashboard-header-wrapper">
                            <div className="dashboard-header-left-wrapper" style={{ paddingLeft: isMobile ? 20 : 0 }}>
                                <p>{user.user.full_name ? user.user.full_name : 'نام کاربری : ' + user.user.username}</p>
                                {
                                    userIsConfirmed === true ? (
                                        <Tag icon={<Icon type="user" />} color="green" style={{ marginLeft: 14 }}>
                                            حساب کاربری فعّال
                                        </Tag>
                                    ) : (
                                        <Tag icon={<Icon type="user" />} color="red" style={{ marginLeft: 14 }}>
                                            حساب کاربری غیر فعّال
                                        </Tag>
                                    )
                                }
                            </div>
                        </div>
                        {
                            userIsConfirmed === true ? (
                                <>
                                    {props.children}
                                </>
                            ) : (
                                <ActivateAccount />
                            )
                        }
                        <div className="dashboard-footer-wrapper">
                            <p>تمامی حقوق برای صرافی بیاتی محفوظ است</p>
                        </div>
                    </div>
                </Col>

                <Sider
                    style={{
                        overflow: 'auto',
                        height: '100vh',
                        position: 'fixed',
                        right: 0,
                        width: 400,
                        minWidth: 400,
                        maxWidth: 400,
                        display: drawerOpen === true ? 'block' : 'none'
                    }}
                >
                    <div style={{ position: 'sticky' }}>
                        <a className='dashboardLogo' href={'/'}>
                            <img src={'../clientAssets/logo.png'} alt="logo" />
                        </a>

                        <MyMenu theMode={'inline'} />

                    </div>
                    <div className="dashboard-logout">
                        <Link to={'/logout'}>

                            <span className="submenu-title-wrapper error">
                                <Button type="danger" block icon={'logout'}>
                                    خروج از حساب کاربری
                                </Button>
                            </span>

                        </Link>
                    </div>
                </Sider>


            </Row>

        )

    


}

